import { createTheme, ThemeOptions } from '@mui/material/styles';
import { defaultsDeep } from 'lodash'
import { muiTheme as defaultTheme } from '../styleUtils'

/** @todo update to new pickers */
/* type PickersTheme = {
  overrides: ThemeOptions['overrides'] & {
    MuiPickersToolbar: ThemeOptions['overrides']['MuiToolbar'] & {
      toolbar: CSSProperties
    },
    MuiPickersToolbarText: {
      toolbarBtnSelected: CSSProperties
      toolbarTxt: CSSProperties
    }
  }
} */

const theme: ThemeOptions /* & PickersTheme  */ = {
  palette: {
    mode: 'dark',
    action: {
      active: "rgba(255, 255, 255, 0.54)",
      disabled: "rgba(255, 255, 255, 0.26)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      focus: "rgba(255, 255, 255, 0.12)",
      hover: "rgba(255, 255, 255, 0.04)",
      selected: "rgba(255, 255, 255, 0.08)",
    },
    background: {
      default: '#111111',
      paper: '#262626',
      selected: 'rgba(255,255,255,0.08)',
    },
    divider: 'rgba(255,255,255,0.12)',
    primary: {},
    secondary: {},
    text: {
      primary: 'rgba(255,255,255,0.87)',
      secondary: 'rgba(255,255,255,0.54)',
      disabled: 'rgba(255, 255, 255, 0.26)',
    },
  },
  typography: {
    h1: {
      color: 'rgba(255,255,255,0.87)',
    },
    h2: {
      color: 'rgba(255,255,255,0.87)',
    },
    h3: {
      color: 'rgba(255,255,255,0.87)',
    },
    h4: {
      color: 'rgba(255,255,255,0.87)',
    },
    h5: {
      color: 'rgba(255,255,255,0.87)',
    },
    h6: {
      color: 'rgba(255,255,255,0.87)',
    },
    subtitle1: {
      color: 'rgba(255,255,255,0.87)',
    },
    subtitle2: {
      color: 'rgba(255,255,255,0.87)',
    },
    caption: {
      color: 'rgba(255,255,255,0.87)',
    },
    overline: {
      color: 'rgba(255,255,255,0.87)',
    },
    body1: {
      color: 'rgba(255,255,255,0.87)'
    },
    body2: {
      color: 'rgba(255,255,255,0.87)'
    }
  },
  components: {
    MuiAvatar: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.text.primary,
        }),
      },
    },

    MuiButton: {
      styleOverrides: {
        text: {
          padding: '8px 8px 4px',
          '&:hover': {
            backgroundColor: 'rgba(128,128,128,0.2)',
          }
        },

        outlined: ({ theme }) => ({
          color: theme.palette.text.primary,
          borderColor: theme.palette.text.disabled,
        }),
      },

      variants: [
        {
          props: { variant: 'contained', color: 'info' },
          style: ({ theme }) => ({
            background: 'none',
            color: theme.palette.primary.main,
            ':hover': {
              background: theme.palette.action.hover,
            },
          }),
        },
      ],
    },

    MuiCheckbox: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&.Mui-checked': {
            color: theme.palette.text.primary,
          },
          '&.MuiCheckbox-indeterminate': {
            color: theme.palette.text.primary,
          },
        }),
      },
    },

    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: 'rgba(128,128,128,0.2)',
          height: '1px'
        },
      },
    },

    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          '&.Mui-disabled': {
            color: 'rgba(128,128,128, 0.54)',
          },
        },
      },
    },

    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: 'rgba(128,128,128, 0.54)',
          },
        },
      },
    },

    MuiIcon: {
      styleOverrides: {
        colorAction: ({ theme }) => ({
          color: theme.palette.text.secondary,
        }),
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.text.primary,

          '&.Mui-disabled': {
            color: theme.palette.text.disabled,
            opacity: 0.3,
          },
        }),
      },
    },

    MuiInput: {
      styleOverrides: {
        underline: {
          '&:before': {
            borderBottomColor: 'rgba(128,128,128,0.2)'
          },
          '&:hover:not(.Mui-disabled):before': {
            borderBottomColor: 'rgba(128,128,128,0.24)',
          },
        },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.text.secondary,
        }),
      },
    },

    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: 'rgba(128,128,128,0.54)',
          },
        },
        input: {
          '&:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 2.5em #262626 inset',
            WebkitTextFillColor: 'rgba(255,255,255,.87)',
          },
        },
      },
    },

    MuiListItemIcon: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.text.primary,
        }),
      },
    },

    /** @todo проверить необходимость */
    MuiListItemText: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.text.primary,
        }),
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.action.disabled,
          },
        }),
      },
    },

    MuiRadio: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          '&.Mui-checked': {
            color: ownerState.disabled ? undefined : theme.palette.text.primary,
          },
        }),
      },
    },

    MuiStepLabel: {
      styleOverrides: {
        label: ({ theme }) => ({
          color: theme.palette.text.secondary,
        }),
      },
    },

    MuiTableRow: {
      styleOverrides: {
        root: {
          '&.MuiTableRow-hover:hover': {
            background: 'rgba(255,255,255,0.04)',
          }
        },
      },
    },

    /** @todo проверить необходимость */
    MuiSelect: {
      styleOverrides: {
        icon: ({ theme }) => ({
          color: theme.palette.text.primary,
        }),
      },
    },

    // MuiSvgIcon: {
    //   styleOverrides: {
    //     root: ({ theme, ownerState }) => ({
    //       color: theme.palette.text.primary,
    //     }),
    //   },
    // },

    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: '0px 2px 1px -1px rgba(128,128,128,0.1), 0px 1px 1px 0px rgba(128,128,128,0.04), 0px 1px 3px 0px rgba(128,128,128,0.02)',
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottomColor: 'rgba(128,128,128,0.2)',
        },
      },
    },

    /** @todo проверить стили пикеров */
    // MuiPickersToolbar: {
    //   styleOverrides: {
    //     toolbar: {
    //       backgroundColor: '#262626'
    //     }
    //   }
    // },
    // MuiPickersToolbarText: {
    //   toolbarBtnSelected: {
    //     color: 'rgba(255,255,255,0.87)'
    //   },
    //   toolbarTxt: {
    //     color: 'rgba(255,255,255,0.54)'
    //   }
    // },
  }
}

export default createTheme(defaultsDeep(theme, defaultTheme))
